function formatea(f) {
  let formateado;
  const fs = f.toString();
  if (fs.length > 6) {
    // Trocear y concatenar
    const parte1 = fs.slice(0, 2);
    const parte2 = fs.slice(2, 4);
    const parte3 = fs.slice(6);
    formateado = `${parte1}.${parte2}.${parte3}.pdf`;
  } else {
    formateado = `${fs}.pdf`;
  }

  return formateado;
}


function formatea2(nombre,fecha){
    let n = nombre.toString();
     if ( n.length > 1 && n.length<=2){
        n='0'+n;
     }else{
         if ( n.length == 1  ){
             n='00'+n;
         }
     }
     const f = fecha.split("-");
     const aa = f[0].toString().substr(2,2); 
     const mm = f[1].toString();
     const formateado = aa +"."+mm+"."+n+'.pdf';
     return formateado;
    
}

function formatea3(nombre ){
     let n = nombre.toString();
     if ( n.length > 1 && n.length<=2){
        n='0'+n;
     }else{
         if ( n.length == 1  ){
             n='00'+n;
         }
     }
     const formateado =  n+'.pdf';
     return formateado;
    
}


async function fetchAllFiles(folderId, apiKey) {
  let archivos = [];
  let pageToken = null;

  do {

 
    const url = new URL("https://www.googleapis.com/drive/v3/files");
    const params = {
      q: `'${folderId}' in parents`,
      key: apiKey,
      pageSize: 100, // máximo por request
      fields: "nextPageToken, files(id, name, mimeType, webViewLink)",
    };
    if (pageToken) params.pageToken = pageToken;

    Object.keys(params).forEach((key) =>
      url.searchParams.append(key, params[key]),
    );

    const res = await fetch(url);
    const data = await res.json();

    archivos.push(...(data.files || []));
    pageToken = data.nextPageToken;
  } while (pageToken);

  return archivos;
}

const state = {
  facturas: [],
  honorarios: [],
  traspasos: [],
  archivo_seleccionado: {},
};
const getters = {
  //getArchivosGdrive: (state) => {
  //    return state.facturas;
  //},

  facturasGoogleDrive: (state) => (f) => {
    const nombreArchivo = formatea(f);
 
    return state.facturas.find((file) => file.name === nombreArchivo);
  },
  honorariosGoogleDrive: (state) => (f,fecha) => {
    const nombreArchivo = formatea2(f,fecha);
    console.log(nombreArchivo);
    return state.honorarios.find((file) => file.name === nombreArchivo);
  },
  traspasosGoogleDrive: (state) => (f ) => {
    const nombreArchivo = formatea3(f );
    console.log(nombreArchivo);
    return state.traspasos.find((file) => file.name === nombreArchivo);
  },
};

const mutations = {
  setFacturas(state, list) {
    state.facturas = list;
  },
  setHonorarios(state, list) {
    state.honorarios = list;
  },
   setTraspasos(state, list) {
    state.traspasos = list;
  },
};

const actions = {

    async leeGoogleDrive({ commit }) {
    console.log('lee google drive');
    try {
      const API_KEY = process.env.VUE_APP_GDRIVE_API_KEY;
      const folderId = process.env.VUE_APP_GDRIVE_FOLDER_FACTURAS
      const archivos = await fetchAllFiles(folderId, API_KEY);
      console.log('archivos totales:', archivos.length);
      commit("setFacturas", archivos);


     const folderId2 = process.env.VUE_APP_GDRIVE_FOLDER_HONORARIOS
      const archivos2 = await fetchAllFiles(folderId2, API_KEY);
      console.log('archivos totales honorarios:', archivos2.length);
      commit("setHonorarios", archivos2);


       const folderId3 = process.env.VUE_APP_GDRIVE_FOLDER_TRASPASOS
      const archivos3 = await fetchAllFiles(folderId3, API_KEY);
      console.log('archivos totales traspasos:', archivos3.length);
      commit("setTraspasos", archivos3);

    } catch (error) {
      console.error("Error leyendo Google Drive:", error);
    }
  },

  async leeGoogleDrive_old({ commit }) {
    console.log("lee google drive");
    try {
      const API_KEY = process.env.VUE_APP_GDRIVE_API_KEY;

      const response = await fetch(
        `https://www.googleapis.com/drive/v3/files?q='${process.env.VUE_APP_GDRIVE_FOLDER_FACTURAS}'+in+parents&key=${API_KEY}`,
      );
      const data = await response.json();

      commit("setFacturas", data.files);

      const response2 = await fetch(
        `https://www.googleapis.com/drive/v3/files?q='${process.env.VUE_APP_GDRIVE_FOLDER_HONORARIOS}'+in+parents&key=${API_KEY}`,
      );
      const data2 = await response2.json();

      commit("setHonorarios", data2.files);
    } catch (error) {
      console.error("Error leyendo Google Drive:", error);
    }
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
